<template>
  <FeatureDetailPage feature-key="time-tracking" />
</template>
